import { inject, Injectable, SimpleChanges } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { LogoutService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Subject } from 'rxjs';
import { LoginDasboardService } from '../login-modal/services/login-dasboard.service';
import { CoreUtilService } from './core-util.service';

@Injectable({
  providedIn: 'root'
})
export class LoginHelperUtilsSupportService {
  coreUtilService = inject(CoreUtilService);
  logoutService = inject(LogoutService);
  loginDashboardService = inject(LoginDasboardService);
  warmState = false;
  unsubscribe = new Subject();

  setCookieToRestrictToPersonal(authenticationConfig?: OauthAEMConfig) {
    this.coreUtilService.setCookieName(
      'restrictToPersonal',
      'personal',
      0,
      true,
      authenticationConfig
    );
  }

  setAccountTypeCookie(
    cookieNameForPicker: string,
    authenticationConfig?: OauthAEMConfig
  ) {
    this.coreUtilService.setCookieName(
      'accountType',
      cookieNameForPicker,
      0,
      true,
      authenticationConfig
    );
  }

  getCallBackUrl(changes: SimpleChanges): string {
    return changes && changes?.callbackurl && changes.callbackurl.currentValue
      ? changes.callbackurl.currentValue
      : '';
  }

  checkForGuestAttribute(changes: SimpleChanges): boolean {
    return (
      changes && changes.warmstate && changes.warmstate.currentValue === 'true'
    );
  }

  isWarmState(changes: SimpleChanges): boolean {
    if (this.checkForGuestAttribute(changes)) {
      this.warmState = true;
    }
    return this.warmState;
  }
}
